import React from 'react'

import Panel from '../../../components/Panel'

const NoMatch = (props) => {
    return(
        <Panel>
             <h1>404 Page not found</h1>
        </Panel>
       
    )
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/pages/Guest/NoMatch/NoMatch.js